<template>
  <div v-if="!dialogue.quoteTitle"></div>
  <dialogue
    v-else
    :quoteTitle="dialogue.quoteTitle"
    :quoteText="dialogue.quoteText"
    :characterDescription="dialogue.characterDescription"
    :imageURL="dialogue.imageURL"
    :alignLeft="dialogue.alignLeft"
    :number="3"
  />
  <div v-if="!card.title"></div>
  <card v-else :title="card.title" :subtitle="card.subtitle" :text="card.text" :imagesURLs="card.imagesURLs" :number="8" />
</template>

<script>
import Dialogue from "@/components/Dialogue";
import Card from "@/components/Card";
import contentfulClient from "@/module/contentful";

export default {
  name: "WaypointsTest",
  components: { Dialogue, Card },
  data() {
    return {
      dialogue: {},
      card: {},
    };
  },
  created: async function() {
    let result = await contentfulClient.getEntries({
      content_type: "wayPoint",
    });

    const content = result.items[1].fields.content;
    console.log("created:function -> result.items", result.items);

    // Handelt es sich um Dialogue oder Card Content?
    if (content.fields.quoteTitle) {
      this.dialogue.quoteTitle = content.fields.quoteTitle;
      this.dialogue.quoteText = content.fields.quoteText;
      this.dialogue.characterDescription = content.fields.characterDescription;
      this.dialogue.imageURL = content.fields.image.fields.file.url;
      this.dialogue.alignLeft = content.fields.alignLeft;
    } else {
      this.card.title = content.fields.title;
      this.card.subtitle = content.fields.subtitle;
      this.card.text = content.fields.text;
      this.card.imagesURLs = content.fields.images.map((image) => image.fields.file.url);
    }
  },
};
</script>

<style scoped></style>
